import * as React from "react";
import { useSelector } from "react-redux";
import Layout from "../Layout";
import Content from "./content";
import InfoLayout from "../UserCenter/components/Layout";
import { RootState } from "../../store/configureStore";

const Commission: React.FC = () => {
  const {
    breadcrumbs = [
      {
        url: "/",
        title: "每家家居",
      },
      {
        title: "我的带单",
        url: "",
      },
    ],
  } = useSelector((state: RootState) => state.CommissionPage);
  return (
    <Layout breadcrumbs={breadcrumbs}>
      <InfoLayout>
        <Content />
      </InfoLayout>
    </Layout>
  );
};

export default Commission;
